import { z } from 'zod';

/** Valeurs du formulaire « Je modifie mes informations personnelles ». */
export interface ChangeInformationsNaissanceValues {
    pays?: string;
    ville?: string;
    nom?: string;
    statut_juridique?: string;
    siren_siret?: string;
}

/**
 * Contrôle des informations de naissance (particulier) ou de la société (`societe`).
 *
 * Reprend l'ancien `validate.js`, qui recevait `societe` en contexte du résolveur.
 */
export const createChangeInformationsNaissanceSchema = (societe: boolean) =>
    z.looseObject({}).superRefine((values, ctx) => {
        const v = values as Record<string, unknown>;
        const errors: Record<string, string> = {};

        const requiredFields = !societe ? ['nom', 'pays', 'ville'] : ['statut_juridique', 'siren_siret'];

        for (const field of requiredFields) {
            if (!v[field] && field === 'pays') {
                errors[field] = 'Le champ est obligatoire, veuillez sélectionner un pays dans la liste';
            } else if (!v[field]) {
                errors[field] = 'Le champ est obligatoire';
            }
        }

        for (const [path, message] of Object.entries(errors)) ctx.addIssue({ code: 'custom', path: [path], message });
    });
